import React, { Component } from 'react'
import { connect } from 'react-redux'
import lscache from 'lscache'
import isEqual from 'lodash.isequal'

import classNames from './Settings.css'
import { updateUser, updateGlobalSettings } from '../redux/users'
import { refreshTokens } from '../redux/auth'
import { showBanner } from '../redux/banners'
import { isSuperAdmin } from '../utils/auth'
import Checklist from '../components/Checklist'
import LoadingSpinner from '../components/LoadingSpinner'
import { SETTINGS_CACHE_KEY, IMAGE_VARIANTS, DEFAULT_SETTINGS } from '../constants'

const DEFAULT_TAB = 'user'

class Settings extends Component {
  state = {
    tab: DEFAULT_TAB,
    data: getData(this.props, DEFAULT_TAB),
    submitting: false
  }
  updateData = (key, value) => {
    this.setState({
      data: {
        ...this.state.data,
        [key]: value
      }
    })
  }
  switchTab = e => {
    const tab = e.target.value
    this.setState({
      tab,
      data: getData(this.props, tab)
    })
  }
  isUnsaved = () => {
    return isEqual(getData(this.props, this.state.tab), this.state.data) === false
  }
  onSubmit = e => {
    e.preventDefault()
    const { user, updateUser, updateGlobalSettings, refreshTokens } = this.props
    const { tab, data } = this.state
    this.setState({ submitting: true })
    if (tab === 'user') {
      updateUser(user.id, {
        ...user,
        settings: JSON.stringify(data)
      }, false).then(this.onSuccess)
    }
    if (tab === 'global') {
      updateGlobalSettings(data).then(this.onSuccess)
    }
    if (tab === 'local') {
      lscache.set(SETTINGS_CACHE_KEY, data)
      refreshTokens().then(this.onSuccess)
    }
  }
  onSuccess = () => {
    this.setState({
      submitting: false
    })
    this.props.showBanner('Settings updated')
  }
  onReset = () => {
    const { refreshTokens, global } = this.props
    const { tab } = this.state
    this.setState({
      data: tab === 'global' ? DEFAULT_SETTINGS : global
    })
    if (tab === 'local') {
      lscache.remove(SETTINGS_CACHE_KEY)
      refreshTokens()
    }
  }
  renderHeader () {
    const { canEditGlobal } = this.props
    const { tab } = this.state
    const renderButton = value => (
      <button
        key={value}
        type='button'
        onClick={this.switchTab}
        value={value}
        className={tab === value ? classNames.smallButtonActive : classNames.smallButton}>
        {value}
      </button>
    )
    return (
      <header className={classNames.header}>
        {renderButton('local')}
        {renderButton('user')}
        {canEditGlobal ? renderButton('global') : null}
      </header>
    )
  }
  render () {
    const { error } = this.props
    const { tab, data, submitting } = this.state
    return (
      <form className={classNames.page} onSubmit={this.onSubmit}>
        {this.renderHeader()}
        <p className={classNames.note}>
          {tab === 'local' && 'Local settings will apply to only this device.'}
          {tab === 'user' && 'User settings will apply to all devices you use.'}
          {tab === 'global' && 'Global settings will apply to all users.'}
        </p>
        <Checklist
          value={data.aws ? [true] : []}
          items={[{
            value: true,
            title: 'Use S3 for images'
          }]}
          onChange={data => this.updateData('aws', data.length === 1)}
        />
        <div className={classNames.label}>
          Local image path
          <input
            type='text'
            disabled={data.aws}
            value={data.imagePath || ''}
            onChange={e => this.updateData('imagePath', e.target.value)}
          />
        </div>
        <div className={classNames.label}>
          Icon variant
          <VariantPicker
            value={data.iconVariant}
            onChange={value => this.updateData('iconVariant', value)}
          />
        </div>
        <div className={classNames.label}>
          Thumbnail variant
          <VariantPicker
            value={data.thumbVariant}
            onChange={value => this.updateData('thumbVariant', value)}
          />
        </div>
        <div className={classNames.label}>
          Display variant
          <VariantPicker
            value={data.displayVariant}
            onChange={value => this.updateData('displayVariant', value)}
          />
        </div>
        <div className={classNames.label}>
          Present variant
          <VariantPicker
            value={data.presentVariant}
            onChange={value => this.updateData('presentVariant', value)}
          />
        </div>
        <input
          type='submit'
          value='Save'
          disabled={submitting || !this.isUnsaved()}
          className={classNames.submit}
        />
        <button
          type='button'
          onClick={this.onReset}
          className={classNames.reset}>
          Reset to {tab === 'global' ? 'system' : 'global'} defaults
        </button>
        <LoadingSpinner show={submitting} />
        {error &&
          <p className={classNames.error}>
            There was an error saving settings
          </p>
        }
      </form>
    )
  }
}

function VariantPicker ({ value, onChange }) {
  return (
    <div>
      {IMAGE_VARIANTS.map(variant => (
        <button
          key={variant}
          type='button'
          onClick={() => onChange(variant)}
          className={value === variant ? classNames.smallButtonActive : classNames.smallButton}>
          {variant}
        </button>
      ))}
    </div>
  )
}

function getData (props, tab) {
  let settings
  if (tab === 'user') {
    settings = props.user.original_settings
  }
  if (tab === 'local') {
    settings = lscache.get(SETTINGS_CACHE_KEY)
  }
  if (tab === 'global') {
    settings = props.global
  }
  return {
    ...DEFAULT_SETTINGS,
    ...props.global,
    ...settings
  }
}

const mapStateToProps = ({ auth, users }) => ({
  user: auth.user,
  global: JSON.parse(auth.user.global_settings),
  local: lscache.get(SETTINGS_CACHE_KEY),
  canEditGlobal: isSuperAdmin(auth.user),
  error: users.error
})

const mapDispatchToProps = {
  updateUser,
  updateGlobalSettings,
  refreshTokens,
  showBanner
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings)



// WEBPACK FOOTER //
// ./src/pages/Settings.js